// @flow
import React from 'react';

export const ExpandableContext = React.createContext<any>();
